import { get, post } from '@/plugins/axios'
/**
 * 获取client_id
 *
 */
export const getClientIdApi = () => {
  return post('/settlement/membership/order/getClientId')
}

/**
* paypal创建订阅订单。（前台）会员普通paypal创建订单
*/
export function createPaypalRechargeOrderApi (data: any) {
  return post('/settlement/membership/order/create/paypal', data)
}

/**
 * 余额充值paypal回调
 *
 * @param {*} data
 */
export const rechargePaypalCaptureApi = (data: any) => {
  return post('/settlement/membership/order/create/paypal/approve', data)
}

/**
* paypal创建订单。（前台）
*/
export function createPaypalWalletApi (data: any) {
  return post('/settlement/wallet/order/create/paypal', data)
}

/**
* paypal capture order。（前台）
*/
export function walletPaypalCaptureApi (params: any) {
  return get('/settlement/wallet/order/capture/paypal', { params })
}

/**
* paypal capture order。（前台）余额充值信用卡捕获订单
*/
export function walletPaypalCardCaptureApi (params: any) {
  return get('/settlement/wallet/order/capture/paypal/credit', { params })
}
/**
* paypal capture order。（前台）
*/
export function membershipPaypalCaptureApi (params: any) {
  return post('/settlement/membership/order/create/paypal/credit/capture', params)
}

/*
 * paypal 获取token
 * @param {*} data
 */
export const getPalpalTokenApi = (params: any) => {
  return post('/settlement/wallet/order/paypal/generate/token', params)
}

/*
 * 获取paypal信用卡
 * @param {*} data
 */
export const getBankCardListApi = (params: any) => {
  return post('/settlement/wallet/order/paypal/payment/token/acquire', params)
}

export const createPaypalCreditPayApi = (params: any) => {
  return post('/settlement/wallet/order/paypal/payment/create/web', params)
}

export const authorizeApi = (params: any) => {
  return post('/settlement/wallet/order/paypal/payment/authorize/web', params)
}

// 保存信用卡信息
export const saveCreditCardApi = (params: any) => {
  return post('/settlement/wallet/order/paypal/payment/token/save', params)
}

// 切换默认卡
export const changeCreditCardDefaultStatusApi = (params: any) => {
  return post('/settlement/wallet/order/paypal/payment/token/default?creditCardId=' + params.creditCardId, {})
}

// 删除信用卡
export const deleteCreditCardApi = (params: any) => {
  return post('/settlement/wallet/order/paypal/payment/token/delete?creditCardId=' + params.creditCardId, {})
}

// 创建信用卡paypal会员订单
export const createVipPaypalCreditCardApi = (params: any) => {
  return post('/settlement/membership/order/create/paypal/credit', params)
}

/**
* 获取韩国站韩元转美元的汇率接口
*/
export function getMembershipRechargeExchangeRateKrw2Usd () {
  return get('/settlement/membership/order/getMembershipRechargeExchangeRateKrw2Usd')
}

/**
* 创建setup token
*/
export function walletOrderPaypalSetupTokenCreate () {
  return post('/settlement/wallet/order/paypal/setup/token/create')
}

/**
* 创建payment token
*/
export function walletOrderPaypalPaymentTokenCreate (setupTokenId:string) {
  return post(`/settlement/wallet/order/paypal/payment/token/create?setupTokenId=${setupTokenId}`)
}

/**
* 信用卡0元支付
*/
export function membershipOrderCreateCreditFree (params: any) {
  return post('/settlement/membership/order/create/credit/free', params)
}
